import MotorbikeTraining from "../assets/LearnersUIimages/Motorbiketraining.jpeg";
import AutoCartraining from "../assets/LearnersUIimages/AutoCartraining.jpg";
import Manualtraining from "../assets/LearnersUIimages/Manualtraining.jpg";
import HomeVisittraining from "../assets/LearnersUIimages/HomeVisittraining.jpg";
import Refreshertraining from "../assets/LearnersUIimages/Refreshertraining.png";
import HeavyVehicletraining from "../assets/LearnersUIimages/HeavyVehicletraining.png";
import { all } from "axios";

export const drivingSchoolData = [
  {
    id: 1,
    name: "Motorbike training",
    image: MotorbikeTraining,
  },
  { id: 2, name: "Home Visit training", image: HomeVisittraining },
  {
    id: 3,
    name: "Auto Car training",
    image: AutoCartraining,
  },
  { id: 4, name: "Manual training ", image: Manualtraining },
  { id: 5, name: "Refresher training", image: Refreshertraining },
  { id: 6, name: "Heavy vehicle  training", image: HeavyVehicletraining },
];

export const englishUser = {
  formTitleFirst: "Driving School",
  formTitleSecond: "Registation",
  logodes: "Upload Your Driving School Logo Here.",
  name: "Learners Name",
  email: "Email",
  hotline: "Hotline",
  service: "Services",
  price: "Prices",
  addPrice: "Add New Price",
  addBranch: "Add New Branch",
  removePrice: "Remove Price",
  removeBranch: "Remove Branch",
  selectVehicleType: "Select Vehicle Type",
  vehicalPrice: "Price",
  branch: "Branches",
  allServices: "All",
  services: [
    { name: "Motorbike Training", id: 1 },
    { name: "Home Visit Training", id: 2 },
    { name: "Auto Car Training", id: 3 },
    { name: "Manual Training", id: 4 },
    { name: "Refresher Training", id: 5 },
    { name: "Heavy Vehicle Training", id: 6 },
  ],
  prices: [
    { type: "Motorbike" },
    { type: "Threewheel" },
    { type: "Car (Auto)" },
    { type: "Car/Van Manual" },
    { type: "Heavy Vehicle" },
    { type: "Prime Mover" },
  ],
  branchName: "Branch Name",
  branchAddress: "Branch Address",
  branchConNumber1: "Branch Contact Number 1",
  branchConNumber2: "Branch Contact Number 2",
  description: "Description",
  desPlaceholder: "Please provide a description between 40 to 100 words...",
  address: "Address",
  regNo: "Registration No",
  submit: "Submit",
  back: "Back",
  branchDistrict: "Branch District",
  branchCity: "Nearest City",
  successMsg:
    "Data Submitted Successfully..!, Please call this number for further process - 071 23 67 846",
  errorMsg: "Failed to submit data. Please try again.",
  validMsg:
    "After filling out this form and entering your data, call this number to have your driving school listed on our website.  - 071 23 67 846",
};

export const sinhalaUser = {
  formTitleFirst: "රියැදුරු පාසල",
  formTitleSecond: "ලියාපදිංචිය",
  logodes: "ඔබේ රියදුරු පාසලේ ලාංඡනය මෙතැනින් ඇතුලත් කරන්න.",
  name: "රියැදුරු පාසල් නම",
  email: "ඊමේල්",
  hotline: "දුරකථන සේවා අංකය",
  service: "අපගේ සේවාවන් ",
  price: "මිල ගණන්",
  addPrice: "නව ඒකකයක් ඇතුලත් කරන්න",
  addBranch: "නව ශාඛාවක් ඇතුලත් කරන්න",
  removePrice: "ඒකකය ඉවත් කරන්න",
  removeBranch: "ශාඛාව ඉවත් කරන්න",
  selectVehicleType: "වාහන වර්ගය තෝරන්න",
  vehicalPrice: "මිල ගණන",
  branch: "ශාඛා",
  allServices: "පහත සියලු සේවා ",
  services: [
    { name: "මෝටර් බයික් පුහුණුව", id: 1 },
    { name: "නිවසට පැමිණෙන පුහුණුව", id: 2 },
    { name: "ඔටෝ කාර් පුහුණුව", id: 3 },
    { name: "මැනුවල් වාහන  පුහුණුව", id: 4 },
    { name: "නැවත පුහුණුව", id: 5 },
    { name: "බර වාහන පුහුණුව", id: 6 },
  ],
  prices: [
    { type: "මෝටර් බයික්" },
    { type: "ත්‍රී රෝද රථ" },
    { type: "කාර් (ඔටෝ)" },
    { type: "කාර්/වෑන් අත්පත්" },
    { type: "බර වාහන වාහන" },
    { type: "ප්‍රයිම් මූවර්" },
  ],
  branchName: "ශාඛා නම",
  branchAddress: "ශාඛා ලිපිනය",
  branchConNumber1: "ශාඛා දුරකථන අංකය 1",
  branchConNumber2: "ශාඛා දුරකථන අංකය 2",
  description: "විස්තරය",
  desPlaceholder: "කරුණාකර වචන 40 සිට 100 අතර විස්තරයක් ලබා දෙන්න...",

  address: "ලිපිනය",
  regNo: "ලියාපදිංචි අංකය",

  submit: "තොරතුරු ඇතුලත් කරන්න",
  back: "ආපසු",
  branchDistrict: "ශාඛාව පිහිටි දිස්ත්‍රික්කය",
  branchCity: "ආසන්නම නගරය",
  successMsg:
    "දත්ත සුරැකීම සාර්ථකයි..! කරුණාකර ඉදිරි ක්‍රියාවලිය සදහා  මෙම අංකයට ඇමතුමක් ලබාගන්න - 071 23 67 846",
  errorMsg: "දත්ත සුරැකීම අසාර්ථකයි. කරුණාකර නැවත උත්සාහ කරන්න.",
  validMsg:
    "මෙම පෝරමය පුරවා දත්ත ඇතුලත් කිරිමෙන් පසු, ඔබගේ රියදුරු පාසල අපගේ වෙබ් අඩවියේ පල කිරීමට මෙම අංකයට ඇමතුමක් ලබා දෙන්න.  - 071 23 67 846",
};

//පෙර පිටුවට

export const tamilUser = {
  formTitleFirst: "ஊர்வல பள்ளி",
  formTitleSecond: "பதிவு",
  logodes: "உங்கள் ஓட்டுநர் பள்ளி லோகோவை இங்கே பதிவேற்றவும்.",
  name: "ஊர்வல பள்ளியின் பெயர்",
  email: "மின்னஞ்சல்",
  hotline: "தொலைபேசி எண்",
  service: "சேவைகள்",
  price: "விலை",
  addPrice: "புதிய விலை சேர்க்கவும்",
  addBranch: "புதிய கிளை சேர்க்கவும்",
  removePrice: "விலையை நீக்கவும்",
  removeBranch: "கிளையை நீக்கவும்",
  selectVehicleType: "வாகன வகையைத் தேர்ந்தெடுக்கவும்",
  vehicalPrice: "விலை",
  branch: "கிளைகள்",
  allServices: "அனைத்து சேவைகளும்",
  services: [
    { name: "மோட்டார் சைக்கிள் பயிற்சி", id: 1 },
    { name: "வீட்டிற்கு வருகை பயிற்சி", id: 2 },
    { name: "ஆட்டோ கார் பயிற்சி", id: 3 },
    { name: "கையேடு பயிற்சி", id: 4 },
    { name: "மறுபடியும் பயிற்சி", id: 5 },
    { name: "கடுமையான வாகன பயிற்சி", id: 6 },
  ],
  prices: [
    { type: "மோட்டார் சைக்கிள்" },
    { type: "மூன்று சக்கர வாகனம்" },
    { type: "கார் (ஆட்டோ)" },
    { type: "கார்/வான் கையேடு" },
    { type: "கடுமையான வாகனம்" },
    { type: "பிரைம் மூவர்" },
  ],
  branchName: "கிளை பெயர்",
  branchAddress: "கிளை முகவரி",
  branchConNumber1: "கிளை தொடர்பு எண் 1",
  branchConNumber2: "கிளை தொடர்பு எண் 2",

  description: "விளக்கம்",
  desPlaceholder: "40 முதல் 100 வார்த்தைகள் உள்ள விளக்கத்தை வழங்கவும்...",

  address: "முகவரி",
  regNo: "பதிவு எண்",

  submit: "சமர்ப்பிக்கவும்",
  back: "பின்னே",
  branchDistrict: " கிளை மாவட்டம்",
  branchCity: "அருகிலுள்ள நகரம்",
  successMsg:
    "தரவு சமர்ப்பிப்பு வெற்றிகரமாக..! தொடர்பு செயல்முறைக்கான இந்த எண்ணை அழைக்கவும் - 071 23 67 846",
  errorMsg:
    "தரவு சமர்ப்பிப்பு தோல்வியடைந்தது. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
  validMsg:
    "இந்தப் படிவத்தை நிரப்பி உங்கள் தரவை உள்ளிட்ட பிறகு, உங்கள் ஓட்டுநர் பள்ளியை எங்கள் வலைத்தளத்தில் பட்டியலிட இந்த எண்ணை அழைக்கவும்.  - 071 23 67 846",
};
